import { post, get, wordpost, geted, postJson } from '../network/index.js'

export default {
  authType: data => {
    return post('/mercWebi/wxAuthorizerInfo/toBind', data)
  },
  goDetail: data => {
    return post('/mercWebi/wxAuthorizerInfo/detail', data)
  },
  //绑定微信公众号
  wxAuthorizerInfobind: data => {
    return post('/mercWebi/wxAuthorizerInfo/bind', data)
  },
  //详细信息
  wxAuthorizerInfodetail: data => {
    return post('/mercWebi/wxAuthorizerInfo/detail', data)
  },
  //获取跳转绑定微信公众号页面
  wxAuthorizerInfotoBind: data => {
    return post('/mercWebi/wxAuthorizerInfo/toBind', data)
  },
  //获取解绑验证码
  getUnbindCode: data => {
    return post('/mercWebi/wxAuthorizerInfo/getUnbindCode', data)
  },
  //微信解绑
  unbind: data => {
    return post('/mercWebi/wxAuthorizerInfo/unbind', data)
  },
  //提交审核
  submitAudit: data => {
    return post('/mercWebi/wxAppAudit/submitAudit', data)
  },
  //检查审核结果
  checkAudit: data => {
    return post('/mercWebi/wxAppAudit/checkAudit', data)
  },
  //检查审核结果
  release: data => {
    return post('/mercWebi/wxAppAudit/release', data)
  },
  //短信条数
  queryCnt: data => {
    return post('/mercWebi/smsInfo/queryCnt', data)
  },
  //短信推送记录
  querySmsList: data => {
    return post('/mercWebi/smsInfo/queryList', data)
  },
  // 短信推送设置列表
  smsSettingListByPage: data => {
    return post('/mercWebi/smsInfo/smsSettingListByPage', data)
  },
  // 短信推送设置
  updateSmsSetting: data => {
    return post('/mercWebi/smsInfo/updateSmsSetting', data)
  },

  //查询外送配置
  queryDelivery: data => {
    return post('/mercWebi/busStoreInfo/queryDelivery', data)
  },

  //更新外送配置
  updateDelivery: data => {
    return post('/mercWebi/busStoreInfo/updateDelivery', data)
  },

  //查询外送区域列表
  queryRegionList: data => {
    return post('/mercWebi/busStoreInfo/queryRegionList', data)
  },
  //绘制外送区域
  addRegion: data => {
    return post('/mercWebi/busStoreInfo/addRegion', data)
  },

  //删除外送区域
  delRegion: data => {
    return post('/mercWebi/busStoreInfo/delRegion', data)
  },

  //新增关联跑腿员
  addWorker: data => {
    return post('/mercWebi/busStoreInfo/addWorker', data)
  },

  //关联跑腿员列表
  queryWorkerList: data => {
    return post('/mercWebi/busStoreInfo/queryWorkerList', data)
  },

  //跑腿员选择列表
  sysWorkerList: data => {
    return post('/mercWebi/busStoreInfo/sysWorkerList', data)
  },

  //删除关联跑腿员
  delWorker: data => {
    return post('/mercWebi/busStoreInfo/delWorker', data)
  },
  //查询优惠券列表
  queryCouponList: data => {
    return post('/mercWebi/couponInfo/queryList', data)
  },
  //优惠券版本列表
  VersionList: data => {
    return post('/mercWebi/couponInfo/queryVersionList', data)
  },
  //新建优惠券
  addCoupon: data => {
    return post('/mercWebi/couponInfo/addCoupon', data)
  },
  //编辑优惠券
  editCoupon: data => {
    return post('/mercWebi/couponInfo/editCoupon', data)
  },
  //优惠券详情
  queryCouponDetail: data => {
    return post('/mercWebi/couponInfo/queryDetail', data)
  },
  //优惠券详情
  queryCount: data => {
    return post('/mercWebi/couponInfo/queryCount', data)
  },
  //优惠券包列表
  queryPack: data => {
    return post('/mercWebi/couponInfo/queryPackageList', data)
  },
  //新建优惠券包
  addPack: data => {
    return post('/mercWebi/couponInfo/addPackage', data)
  },
  //编辑优惠券包
  updatePack: data => {
    return post('/mercWebi/couponInfo/updatePackage', data)
  },
  //修改优惠券包状态
  addPackStatus: data => {
    return post('/mercWebi/couponInfo/updatePackageStatus', data)
  },
  //券包详情
  PackageDetail: data => {
    return post('/mercWebi/couponInfo/queryPackageDetail', data)
  },
  //作废优惠券
  cancellationUserCoupon: data => {
    return post('/mercWebi/userInfo/userCouponStatus', data)
  },

  //新增营销活动
  addActivity: data => {
    return post('/mercWebi/busMercActivity/add', data)
  },
  //查询详情
  queryActivityDetail: data => {
    return post('/mercWebi/busMercActivity/queryDetail', data)
  },
  //列表营销活动
  queryActivityList: data => {
    return post('/mercWebi/busMercActivity/queryList', data)
  },
  //编辑营销活动
  updateActivity: data => {
    return post('/mercWebi/busMercActivity/update', data)
  },

  // 修改营销活动状态
  updateStatus: data => {
    return post('/mercWebi/busMercActivity/updateStatus', data)
  },
  // 修改优惠券状态
  updateCouponStatus: data => {
    return post('/mercWebi/couponInfo/updateStatus', data)
  },

  // 新增营销活动
  addMercActivity: data => {
    return post('/mercWebi/busMercActivity/add', data)
  },

  // 店铺选择列表
  selectStoreList: data => {
    return post('/mercWebi/busStoreInfo/selectList', data)
  },
  // 参与活动用户统计列表
  participantList: data => {
    return post('/mercWebi/busMercActivity/participantList', data)
  },
  // 参与活动用户统计列表
  participantStatistic: data => {
    return post('/mercWebi/busMercActivity/participantStatistic', data)
  },
  // 被邀请人列表
  inviteeList: data => {
    return post('/mercWebi/busMercActivity/inviteeList', data)
  },
  // 拼团管理 - 分页查询拼团列表
  listPartakeInfo: data => {
    return post('/sWebi/swPartake/listPartakeInfo', data)
  },

  // 拼团管理 - 分页查询组团列表
  listClusterInfo: data => {
    return post('/sWebi/swPartake/listClusterInfo', data)
  },

  // 拼团管理 - 新增拼团信息
  insertPartake: data => {
    return post('/sWebi/swPartake/insertPartake', data)
  },

  // 拼团管理 - 根据拼团id获取拼团详情
  partakeDetail: data => {
    return get('/sWebi/swPartake/listPartakeById', data)
  },

  // 拼团管理 - 修改拼团信息
  updatePartake: data => {
    return post('/sWebi/swPartake/updatePartake', data)
  },

  // 拼团管理 - 统计拼团数量
  countPartakeInfo: data => {
    return post('/sWebi/swPartake/countPartakeInfo', data)
  },

  // 拼团管理 - 统计组团数量
  countClusterInfo: data => {
    return post('/sWebi/swPartake/countClusterInfo', data)
  },
  // 广告投送 - 新增广告
  insertAdvertise: data => {
    return post('/mercWebi/webAdvertise/insertAdvertise', data)
  },
  // 广告投送 - 修改广告
  modifyAdvertise: data => {
    return post('/mercWebi/webAdvertise/modifyAdvertise', data)
  },
  // 广告投送 - 修改广告状态
  modifyStatus: data => {
    return post('/mercWebi/webAdvertise/modifyAdvertiseStatus', data)
  },
  // 广告投送 - 获取广告位置列表
  listAdvertisePosition: data => {
    return post('/mercWebi/webAdvertise/listAdvertisePosition', data)
  },
  // 广告投送 - 获取广告列表
  listAdvertise: data => {
    return post('/mercWebi/webAdvertise/listAdvertise', data)
  },
  // 广告投送 - 根据分站id获取店铺
  listStoreByStationId: data => {
    return get('/sWebi/webAdvertise/listStoreByStationId', data)
  },
  // 广告投送 - 删除广告
  deleteAdvertise: data => {
    return get('/mercWebi/webAdvertise/deleteAdvertise', data)
  },
  // 广告投送 - 广告明细
  advertiseDetail: data => {
    return get('/mercWebi/webAdvertise/listAdvertiseById', data)
  },
  // 广告投送-位置上移下移
  moveAdvertise: data => {
    return post('/mercWebi/webAdvertise/moveAdvertise', data)
  },

  updateWxappParam: data => {
    return post('/mercWebi/mercInfo/updateWxappParam', data)
  },

  queryCustInfo: () => {
    return get('/mercWebi/mercInfo/queryInfo')
  },
  queryApplyList: data => {
    return post('/mercWebi/mercInfo/queryApplyList', data)
  },
  //校验小程序订阅消息
  checkWxappTemplate: data => {
    return post('/mercWebi/wxAppAudit/checkWxappTemplate', data)
  },
  //更新小程序订阅消息
  refreshWxappTemplate: data => {
    return post('/mercWebi/wxAppAudit/refreshWxappTemplate', data)
  },
  //优卡列表
  queryCardList: data => {
    return post('/mercWebi/busGiftCard/queryList', data)
  },

  //添加
  addCard: data => {
    return post('/mercWebi/busGiftCard/add', data, {
      headers: { 'Content-Type': 'application/json' }
    })
  },
  //查询详情
  queryCardDetail: data => {
    return post('/mercWebi/busGiftCard/queryDetail', data)
  },
  // 删除优卡
  deleteCard: data => {
    return post('/mercWebi/busGiftCard/delete', data)
  },
  // 编辑优卡
  updateCard: data => {
    return post('/mercWebi/busGiftCard/update', data, {
      headers: { 'Content-Type': 'application/json' }
    })
  },
  // 优卡置顶
  busGiftCardTop: data => {
    return post('/mercWebi/busGiftCard/top', data)
  },
  // 优卡取消置顶
  busGiftCardCancelTop: data => {
    return post('/mercWebi/busGiftCard/cancelTop', data)
  },

  //店铺取送设置详情
  queryGetOrSendDetail: data => {
    return get('/storeWashSettings/detail', data)
  },
  addQyNoticeRecipient: data => {
    return postJson('/mercWebi/qyNoticeRecipient/addQyNoticeRecipient', data)
  },
  //店铺取送设置修改
  updateGetOrSend: data => {
    return post('/storeWashSettings/update', data)
  },
  //店铺取送设置修改第三方下单api
  removeStoreApi: data => {
    return post('/storeWashSettings/removeApi', data)
  },
  //店铺取送设置列表
  queryStoreWashList: data => {
    return post('/storeWashSettings/queryList', data)
  },
  //店铺取送设置详情
  storeWashDetail: () => {
    return get('/storeWashSettings/detail')
  },
  //店铺取送设置添加
  storeWashAdd: data => {
    return post('/storeWashSettings/add', data)
  },
  //子账号列表
  accountList: data => {
    return geted('/storeWashSettings/account-list', data)
  },
  //设置公众号通知接收人
  accountNoticePerson: data => {
    return postJson('/storeWashSettings/official-account-notice-set', data)
  },

  //衣物管理
  washList: data => {
    return post('/mercWebi/washOrder/washList', data)
  },
  //代工衣物列表（路径为临时定义，正式接口出来后替换）
  outsourceWashList: data => {
    return post('/mercWebi/washOrder/queryOEMClothingList', data)
  },
  //衣物管理详情
  washOrder: data => {
    return post('/mercWebi/washOrder/washOrder', data)
  },
  //桌码列表
  getTableCodeList: data => {
    return post('/mercWebi/tableCode/getTableCodeList', data)
  },
  //添加桌码
  addTableCode: data => {
    return post('/mercWebi/tableCode/addTableCode', data)
  },
  //删除桌码
  deleteTableCodes: data => {
    return post('/mercWebi/tableCode/deleteTableCodes', data)
  },
  //修改桌码号
  updateTableCodeNo: data => {
    return post('/mercWebi/tableCode/updateTableCodeNo', data)
  },
  //桌码详情
  queryTableCodeDetails: data => {
    return get('/mercWebi/tableCode/queryTableCodeDetails', data)
  },
  //手动发券-根据手机号码判断是否为新用户
  queryIsNewUser: data => {
    return post('/mercWebi/userInfo/queryIsNewUser', data)
  },
  //根据多个手机号码查询用户信息
  queryUserByMobileNos: data => {
    return post('/mercWebi/userInfo/query-by-mobiles', data)
  },
  //手动发券
  manualCouponIssuance: data => {
    return post('/mercWebi/userInfo/couponIssuanceManual', data)
  },
  //优卡兑换码列表
  queryCradExchangeList: data => {
    return post('/mercWebi/busGiftCard/queryCradExchangeList', data)
  },
  //修改兑换码状态
  updateCradExchangeForStatus: data => {
    return post('/mercWebi/busGiftCard/updateCradExchangeForStatus', data)
  },
  //新建优卡兑换码
  addCradExchange: data => {
    return post('/mercWebi/busGiftCard/addCradExchange', data)
  },
  //查询管理员手机号
  administratorPhone: data => {
    return post('/mercWebi/busGiftCard/administratorPhone', data)
  },
  //发送管理员短信验证码
  getLoginCode: data => {
    return post('/mercWebi/busGiftCard/getLoginCode', data)
  },
  //管理员验证码验证
  checkCode: data => {
    return post('/mercWebi/busGiftCard/checkCode', data)
  },
  //新建兑换码后导出
  exportCardExchange: data => {
    return wordpost('/mercWebi/busGiftCard/exportCardExchange', data)
  },
  //按照条件导出
  queryCradExchangeExport: data => {
    return wordpost('/mercWebi/busGiftCard/queryCradExchangeExport', data)
  },
  //京东结算卡分页列表
  settleCardPage: data => {
    return get(`/express/jd/settle-card/page?businessBodyId=${data.businessBodyId}&pageSize=${data.pageSize}&startRow=${data.startRow}`)
  },
  //京东账号 - 查询
  getExpressConfig: data => {
    return post('/express/jd/ownAccount/getJDExpressConfigString', data)
  },
  //京东账号 - 添加
  expressConfigAdd: data => {
    return post('/express/jd/ownAccount/addJDExpressConfigInfo', data)
  },
  //京东账号 - 修改
  expressConfigUpdate: data => {
    return post('/express/jd/ownAccount/updateJDExpressConfigInfo', data)
  },
  //京东账号 - 详情
  expressConfigDetail: data => {
    return post('/express/jd/ownAccount/getJDExpressConfigDetailString', data)
  },
  //京东结算卡新建
  settleCardAdd: data => {
    return post('/express/jd/settle-card/add', data)
  },
  //京东结算卡详情
  settleCardDetail: data => {
    return get(`/express/jd/settle-card/detail?id=${data.id}`)
  },
  //京东结算卡修改
  settleCardUpdate: data => {
    return post('/express/jd/settle-card/update', data)
  },
  //京东结算卡冻结
  settleCardFreeze: data => {
    return post('/express/jd/settle-card/freeze', data)
  },
  //京东结算卡取件/送件备注修改
  settleCardRemarkUpdate: data => {
    return post('/express/jd/settle-card/remark-update', data)
  },
  //结算卡列表
  settleCardList: data => {
    return geted('/store-express/settle-card/list', data)
  },
  //京东结算卡充值-微信支付码生成
  createWXQrCode: data => {
    return post('/platform/expressParam/createWXQrCode', data)
  },
  //京东结算卡充值-判断是否充值成功
  queryRecordForSeq: data => {
    return post('/platform/expressParam/queryRecordForSeq', data)
  },
  //京东结算卡充值-创建seq
  createSeq: data => {
    return post('/platform/expressParam/createSeq', data)
  },
  //京东结算卡扣费记录
  queryKoufeiList: data => {
    return post('/express/jd/queryCardDeductRecord', data)
  },
  //京东结算卡主体列表
  queryBusinessBodyList: data => {
    return get('/express/jd/business-body/list', data)
  },

  //顺丰账号 - 查询
  getSfExpressConfig: data => {
    return post('/express/sf/ownAccount/getSFExpressConfigString', data)
  },
  //顺丰结算卡分页列表
  sfSettleCardPage: data => {
    return get(`/express/sf/settle-card/page?businessBodyId=${data.businessBodyId}&pageSize=${data.pageSize}&startRow=${data.startRow}`)
  },
  //顺丰结算卡主体列表
  querySfBusinessBodyList: data => {
    return get('/express/sf/business-body/list', data)
  },
  //顺丰账号 - 添加
  sfExpressConfigAdd: data => {
    return post('/express/sf/ownAccount/addSFExpressConfigInfo', data)
  },
  //顺丰结算卡新建
  sfSettleCardAdd: data => {
    return post('/express/sf/settle-card/add', data)
  },
  //顺丰账号 - 详情
  sfExpressConfigDetail: data => {
    return post('/express/sf/ownAccount/getSFExpressConfigDetailString', data)
  },
  //顺丰结算卡详情
  sfSettleCardDetail: data => {
    return get(`/express/sf/settle-card/detail?id=${data.id}`)
  },
  //顺丰账号 - 修改
  sfExpressConfigUpdate: data => {
    return post('/express/sf/ownAccount/updateSFExpressConfigInfo', data)
  },
  //顺丰结算卡取件/送件备注修改
  sfSettleCardRemarkUpdate: data => {
    return post('/express/sf/settle-card/remark-update', data)
  },
  //顺丰结算卡扣费记录
  querySfKoufeiList: data => {
    return post('/platform/sf/expressParam/queryCardDeductRecord', data)
  },
  //顺丰结算卡充值记录
  querySFRechargeList: data => {
    return post('/platform/sf/expressParam/queryRechargeList', data)
  },

  //查询美团授权信息
  queryMeituanInfo: data => {
    return post('/mercWebi/mercMeituanInfo/queryMeituanInfo', data)
  },
  //查询美团授权
  reToAuth: data => {
    return post('/dzopen/book/token', data)
  },
  //美团点评服务时间
  updateMeituanInfo: data => {
    return post('/mercWebi/mercMeituanInfo/updateMeituanInfo', data)
  },
  //快递结算卡设置
  settleCardSeting: data => {
    return post('/store-express/settle-card/setting', data)
  },
  //送件设置删除
  settleCardDelete: data => {
    return post('/store-express/settle-card/delete', data)
  },
  //京东结算卡充值-创建seq-支付宝
  createAlipayQrCode: data => {
    return post('/platform/expressParam/createAlipayQrCode', data)
  },
  //查询发货管理信息详情
  queryWxAuthorizerInfoDetails: data => {
    return post('/mercWebi/wxAuthorizerInfo/queryWxAuthorizerInfoDetails', data)
  },
  //修改发货管理信息
  updateWxAuthorizerInfo: data => {
    return post('/mercWebi/wxAuthorizerInfo/updateWxAuthorizerInfo', data)
  },
  //快递信息分页查询
  deliveryPage: data => {
    return post('/express/page', data)
  },
  // 快递信息详情
  queryExpressDetail: data => {
    return post('/express/queryExpressDetail', data)
  },
  // 添加请ta营销活动
  addInviteHim: data => {
    return post('/mercWebi/inviteHim/addInviteHim', data)
  },
  // 修改请ta营销活动
  updateInviteHim: data => {
    return post('/mercWebi/inviteHim/updateInviteHim', data)
  },
  // 查询请ta营销活动详情
  queryInviteDetails: data => {
    return post('/mercWebi/inviteHim/queryInviteDetails', data)
  },
  // 查询请ta活动列表
  queryInviteActivityList: data => {
    return post('/mercWebi/inviteHim/queryActivityList', data)
  },
  //京东结算卡/同城配送--充值记录--充值类型 (1京东结算卡 2同城配送)
  queryRechargeList: data => {
    return post('/platform/expressParam/queryRechargeList', data)
  },
  // 同城配送
  // 开关
  queryCityDeliveryIsEnable: data => {
    return post('/expressWebi/cityDelivery/queryCityDeliveryIsEnable', data)
  },
  // 基本信息
  queryDeliveryBasicInfo: data => {
    return post('/expressWebi/cityDelivery/queryCityDeliveryStoreListByStore', data)
  },
  // 修改
  updateDeliveryInfo: data => {
    return post('/expressWebi/cityDelivery/updateCityDeliveryStoreInfo', data)
  },
  // 排序
  deliverySort: data => {
    return post('/expressWebi/cityDelivery/updateCityDeliveryStoreSort', data)
  },
  //充值-创建Seq
  cityCreateSeq: data => {
    return post('/expressWebi/cityDelivery/createSeq', data)
  },
  //充值-微信支付码生成
  cityCreateWXQrCode: data => {
    return post('/expressWebi/cityDelivery/createWXQrCode', data)
  },
  //充值-支付宝支付码生成
  cityCreateAlipayQrCode: data => {
    return post('/expressWebi/cityDelivery/createAlipayQrCode', data)
  },
  //充值-判断是否充值成功
  cityQueryRecordForSeq: data => {
    return post('/expressWebi/cityDelivery/queryRecordForSeq', data)
  },
  // 扣费记录查询
  getDeductionRecordsList: data => {
    return post('/expressWebi/cityDelivery/getDeductionRecordsList', data)
  },
  // 列表
  getPromoCodeInfoList: data => {
    return post('/mercWebi/promoCode/getPromoCodeInfoList', data)
  },
  // 新建
  addPromoCodeInfo: data => {
    return post('/mercWebi/promoCode/addPromoCodeInfo', data)
  },
  // 修改
  updatePromoCodeInfo: data => {
    return post('/mercWebi/promoCode/updatePromoCodeInfo', data)
  },
  // 详情
  getPromoCodeDetail: data => {
    return post('/mercWebi/promoCode/getPromoCodeDetail', data)
  },
  // 添加兑换密钥
  addExchangeSecreKey: data => {
    return post('/mercWebi/promoCode/addExchangeSecreKey', data)
  },
  // 兑换密钥列表
  getPromoCodeExchangeList: data => {
    return post('/mercWebi/promoCode/getPromoCodeExchangeList', data)
  },
  // 兑换密钥-修改状态
  updateExchangeStatus: data => {
    return post('/mercWebi/promoCode/updateExchangeStatus', data)
  },
  // 兑换密钥-进行打标签
  addExchangeLabel: data => {
    return post('/mercWebi/promoCode/addExchangeLabel', data)
  },
  // 兑换密钥-删除标签
  deleteExchangeLabel: data => {
    return post('/mercWebi/promoCode/deleteExchangeLabel', data)
  },
  // 优惠码-新建后导出
  exportPromoExchange: data => {
    return wordpost('/mercWebi/promoCode/exportPromoExchange', data)
  },
  //按照条件导出
  exportPromoExchangeByParams: data => {
    return wordpost('/mercWebi/promoCode/exportPromoExchangeByParams', data)
  },
  // 小程序自定义菜单 - add
  addCustomMenu: data => {
    return postJson('/mercWebi/customMenu/addCustomMenu', data)
  },
  // 小程序自定义菜单 - del
  delCustomMenu: data => {
    return post('/mercWebi/customMenu/delCustomMenu', data)
  },
  // 小程序自定义菜单 - del
  queryCustomMenu: data => {
    return post('/mercWebi/customMenu/queryCustomMenu', data)
  },

  // 设置取件时间方案
  modifyMercDyTime: data => {
    return post('/mercWebi/dy/modifyMercDy', data)
  },
  // 查询商家取件时间方案
  queryMercDyTime: data => {
    return post('/mercWebi/dy/queryMercDy', data)
  },
  // 设置抖音商家参数
  modifyMercDyConfig: data => {
    return post('/mercWebi/dy/modifyMercDyConfig', data)
  },

  // 查询抖音团购商品列表
  queryMercDyGroupBuying: data => {
    return post('/mercWebi/dy/restrict/page', data)
  },
  // 创建抖音团购商品
  createMercDyGroupBuying: data => {
    return post('/mercWebi/dy/restrict/create', data)
  },
  // 更新抖音团购商品
  updateMercDyGroupBuying: data => {
    return post('/mercWebi/dy/restrict/update', data)
  },
  // 删除抖音团购商品
  deleteMercDyGroupBuying: data => {
    return post('/mercWebi/dy/restrict/delete', data)
  },

  // 家政功能-详情
  getHomemakingSettings: data => {
    return get(`/mercWebi/storeHomemakingSettings/detail/${data}`)
  },

  // 家政功能-修改
  updateHomemakingSettings: data => {
    return post('/mercWebi/storeHomemakingSettings/update', data)
  },

  // 家政功能-新增
  addHomemakingSettings: data => {
    return post('/mercWebi/storeHomemakingSettings/add', data)
  },

  // 家政功能-设置通知接收人
  setHomemakingOfficialPerson: data => {
    return postJson('/mercWebi/storeHomemakingSettings/official-account-notice-set', data)
  },

  // 家政功能-设置通知子账号列表
  getHomemakingAccountList: data => {
    return geted('/mercWebi/storeHomemakingSettings/account-list', data)
  },

  // 分销-团长列表
  queryLeaderList: data => {
    return post('/mercWebi/teamLeader/queryLeaderList', data)
  },

  // 分销-团队/用户人数
  queryGroupMemberList: data => {
    return post('/mercWebi/teamLeader/queryGroupMemberList', data)
  },

  // 分销-添加上级
  addLeader: data => {
    return post('/mercWebi/teamLeader/addLeader', data)
  },

  // 分销-移除上级
  delLeader: data => {
    return post('/mercWebi/teamLeader/delLeader', data)
  },

  // 分销-解除关系
  removeLeader: data => {
    return post('/mercWebi/teamLeader/removeLeader', data)
  },

  // 分销-分佣列表
  queryOrderCommission: data => {
    return post('/mercWebi/teamLeader/queryOrderCommission', data)
  },

  // 分销-设置
  getDistributionParam: data => {
    return post('/mercWebi/mercInfo/getDistributionParam', data)
  },

  // 分销-设置
  saveDistributionParam: data => {
    return post('/mercWebi/mercInfo/saveDistributionParam', data)
  },

  // 分销-修改团长分佣比例
  modifyCommission: data => {
    return post('/mercWebi/teamLeader/modifyCommission', data)
  },

  // 分销-修改商品分佣过期时间
  modifyCommissionExpireDate: data => {
    return post('/mercWebi/teamLeader/modifyCommissionExpireDate', data)
  },

  // 分销-团长与下级列表
  queryLeaderRelList: data => {
    return post('/mercWebi/teamLeader/queryLeaderRelList', data)
  },

  // 分销-修改团长归属团体单位
  editLeaderRelTeamUnit: data => {
    return post('/mercWebi/teamLeader/editTeamUnit', data)
  },

  // 应用-保险列表
  getInsureInfoList: data => {
    return postJson('/ext/insureInfo/list', data)
  },

  // 应用-保险详情
  getInsureInfoDetail: data => {
    return postJson('/ext/insureInfo/detail', data)
  },

  // 配单-店铺配单衣物列表
  getFindorderList: data => {
    return post('/mercWebi/findorder/getFindorderList', data)
  },

  // 团体单位-分页列表
  getTeamUnitList: data => {
    return post('/mercWebi/teamUnit/listTeamUnit', data)
  },
  // 团体单位-下拉列表
  getTeamUnitSelectList: data => {
    return post('/mercWebi/teamUnit/listTeamUnitNotPage', data)
  },
  // 团体单位-添加，编辑
  saveTeamUnit: data => {
    return post('/mercWebi/teamUnit/saveTeamUnit', data)
  },
  // 团体单位-详情
  getTeamUnitDetail: data => {
    return post('/mercWebi/teamUnit/queryTeamUnit', data)
  },
  // 团体单位-删除
  deleteTeamUnit: data => {
    return post('/mercWebi/teamUnit/deleteTeamUnit', data)
  },
  // 团体单位-单位分组编辑，添加
  saveTeamUnitGroup: data => {
    return post('/mercWebi/teamUser/saveTeamUnitGroup', data)
  },
  // 团体单位-单位分组
  getListTeamUnitGroup: data => {
    return post('/mercWebi/teamUser/listTeamUnitGroup', data)
  },
  // 团体单位-删除单位分组
  deleteGroupById: data => {
    return post('/mercWebi/teamUser/deleteGroupById', data)
  },
  // 团体单位-分组排序
  sortTeamUnitGroup: data => {
    return post('/mercWebi/teamUser/sortTeamUnitGroup', data)
  },
  // 团体单位-分组用户
  getListGroupUser: data => {
    return post('/mercWebi/teamUser/listGroupUser', data)
  },
  // 团体单位-添加分组用户
  addGroupUser: data => {
    return post('/mercWebi/teamUser/addGroupUser', data)
  },
  // 团体单位-编辑分组用户
  editGroupUser: data => {
    return post('/mercWebi/teamUser/editGroupUser', data)
  },
  // 团体单位-删除分组用户
  deleteGroupUser: data => {
    return post('/mercWebi/teamUser/deleteGroupUser', data)
  },

  // 智能设备
  querySmartDevice: data => {
    return post('/mercWebi/busStoreInfo/querySmartDevice', data)
  },
  // 智能设备-列表
  querySmartDeviceList: data => {
    return post('/mercWebi/smartDevice/listByPage', data)
  },
  // 智能设备-详情
  smartDeviceDetail: data => {
    return post('/mercWebi/smartDevice/smartDeviceDetail', data)
  },
  // 智能设备-刷新设备状态
  refreshDeviceStatus: data => {
    return post('/mercWebi/smartDevice/refreshStatus', data)
  },
  // 智能设备-发送指令
  optSmartDevice: data => {
    return post('/mercWebi/smartDevice/optRobot', data)
  },
  // 智能设备-添加设备图片
  saveDeviceImages: data => {
    return post('/mercWebi/smartDevice/saveDeviceImages', data)
  },
  // 智能设备-删除设备图片
  deleteDeviceImage: data => {
    return post('/mercWebi/smartDevice/deleteDeviceImage', data)
  },
  // 智能设备-设备图片排序
  deviceImageSort: data => {
    return post('/mercWebi/smartDevice/deviceImageSort', data)
  },
  // 智能设备-修改设备袋子数量
  updateRoadBagNum: data => {
    return post('/mercWebi/smartDevice/updateRoadBagNum', data)
  },
  // 智能设备-语音设置
  updateVoiceSetting: data => {
    return post('/mercWebi/smartDevice/updateVoiceSetting', data)
  },
  // 智能设备-查询语音设置
  getVoiceSettingList: data => {
    return post('/mercWebi/smartDevice/findVoiceSettingList', data)
  },
  // 智能设备-更新箱格状态
  smartDeviceUpdateBox: data => {
    return post('/mercWebi/smartDevice/updateBox', data)
  },
  // 智能设备-箱格解绑订单
  smartDeviceUnbindOrder: data => {
    return post('/mercWebi/smartDevice/unbindOrder', data)
  },
  // 智能设备-手动开箱
  smartDeviceOpenBox: data => {
    return post('/mercWebi/smartDevice/openBox', data)
  },
  // 智能设备-查询门状态
  queryDoorStatus: data => {
    return post('/mercWebi/smartDevice/queryDoorStatus', data)
  },

  // 会话记录列表
  queryChatLogList: data => {
    return post('/mercWebi/chatLog/queryList', data)
  },

  // 会话记录详情
  queryChatLogDetail: data => {
    return post('/mercWebi/chatLog/queryDetail', data)
  },

  // 抖音商品列表
  queryDyListPage: data => {
    return post('/mercWebi/dy/goods/queryListPage', data)
  },
  // 抖音商品新增
  insertThirdGroupInfo: data => {
    return post('/mercWebi/dy/goods/insertThirdGroupInfo', data)
  },
  // 抖音商品编辑
  updateThirdGroupInfo: data => {
    return post('/mercWebi/dy/goods/updateThirdGroupInfo', data)
  },
  // 抖音商品品类
  queryCategoryList: data => {
    return post('/mercWebi/dy/goods/queryCategoryList', data)
  },
  // 抖音适用门店
  queryDyStoreList: data => {
    return post('/mercWebi/dy/goods/queryDyStoreList', data)
  },
  // 抖音商品查询
  queryDyDetail: data => {
    return post('/mercWebi/dy/goods/queryDetailById', data)
  },
  // 抖音商品上下架
  operateDyGoods: data => {
    return post('/mercWebi/dy/goods/operate', data)
  },
  // 抖音商品删除
  deleteDyGoods: data => {
    return post('/mercWebi/dy/goods/deleteAllThirdGroupInfoById', data)
  },
  // 抖音商品排序
  sortDyGoods: data => {
    return post('/mercWebi/dy/goods/modifyThirdGroupSort', data)
  },
  // 抖音商品同步
  synchronousDyGoods: data => {
    return post('/mercWebi/dy/goods/syncGoods', data)
  },
  // 抖音商品列表统计
  getDyGoodsCount: data => {
    return post('/mercWebi/dy/goods/countStatusList', data)
  },
  // 抖音商品适用店铺
  getDyStoreList: data => {
    return post('/mercWebi/dy/goods/countDyStoreList', data)
  },

  // 店铺伙伴-列表
  getStorePartnerList: data => {
    return post('/mercWebi/storePartner/getStorePartnerList', data)
  },
  // 店铺伙伴-新增
  addStorePartner: data => {
    return post('/mercWebi/storePartner/addStorePartner', data)
  },
  // 店铺伙伴-分佣记录
  partnerCommissionList: data => {
    return post('/mercWebi/storePartner/partnerCommissionList', data)
  },
  // 店铺伙伴-启用/禁用
  enableStorePartner: data => {
    return post('/mercWebi/storePartner/enableStorePartner', data)
  },
  // 店铺伙伴-查询商家伙伴
  getMercPartner: data => {
    return post('/mercWebi/storePartner/getMercPartner', data)
  },
  // 店铺伙伴-绑定新伙伴
  bindStorePartner: data => {
    return post('/mercWebi/storePartner/bindStorePartner', data)
  },
  // 店铺伙伴-修改分佣
  updateStorePartner: data => {
    return post('/mercWebi/storePartner/updateStorePartner', data)
  },
  // 店铺伙伴-店铺伙伴列表(不分页)
  getListByStoreId: data => {
    return post('/mercWebi/storePartner/getListByStoreId', data)
  },
  // 店铺伙伴-移除店铺伙伴
  deleteStorePartner: data => {
    return post('/mercWebi/storePartner/deleteStorePartner', data)
  },

  // 营销活动-消费赠券列表
  consumeCouponRuleList: data => {
    return postJson('/mercWebi/consumeCouponRule/queryList', data)
  },
  // 营销活动-消费赠券添加
  consumeCouponRuleSave: data => {
    return postJson('/mercWebi/consumeCouponRule/saveRule', data)
  },
  // 营销活动-消费赠券启用/停用
  consumeCouponRuleStatus: data => {
    return postJson('/mercWebi/consumeCouponRule/updateStatus', data)
  },
  // 营销活动-消费赠券详情
  consumeCouponRuleDetail: data => {
    return get(`/mercWebi/consumeCouponRule/queryDetail/${data.id}`)
  },
  // 营销活动-消费赠券删除
  consumeCouponRuleDelete: data => {
    return get(`/mercWebi/consumeCouponRule/deleteRule/${data.id}`)
  },

  // 洗衣码-批次新建/编辑
  saveWashCode: data => {
    return post(`/mercWebi/washCode/save`, data)
  },
  // 洗衣码-批次列表
  getWashCodeList: data => {
    return post(`/mercWebi/washCode/listByPage`, data)
  },
  // 洗衣码-批次详情
  getWashCodeDetail: data => {
    return post(`/mercWebi/washCode/batchDetail`, data)
  },
  // 洗衣码-批次状态修改
  updateWashCodeStatus: data => {
    return post(`/mercWebi/washCode/updateCodeStatus`, data)
  },

  // 取送-到店 服务管家列表
  queryServiceButler: data => {
    return post(`/mercWebi/webAccountInfo/queryServiceButler`, data)
  },

  // api下单-配置列表
  apiPlaceOrderConfigList: data => {
    return post(`/mercWebi/apiPlaceOrderConfig/apiPlaceOrderConfigList`, data)
  },
  // api下单-配置列表
  saveApiPlaceOrderConfig: data => {
    return post(`/mercWebi/apiPlaceOrderConfig/saveApiPlaceOrderConfig`, data)
  },
  // api下单-配置列表
  apiPlaceOrderConfigDetail: data => {
    return post(`/mercWebi/apiPlaceOrderConfig/apiPlaceOrderConfigDetail`, data)
  },
  // api下单-已绑定的店铺列表
  queryBindApiStoreList: data => {
    return post(`/mercWebi/apiPlaceOrderConfig/queryBindApiStoreList`, data)
  },
  // api下单-未绑定的店铺列表
  queryNotBindApiStoreList: data => {
    return post(`/mercWebi/apiPlaceOrderConfig/queryNotBindApiStoreList`, data)
  },
  // api下单-批量绑定店铺
  batchBindApi: data => {
    return post(`/mercWebi/apiPlaceOrderConfig/batchBindApi`, data)
  },
  // api下单-移除绑定店铺
  removeAllStoreApi: data => {
    return post(`/mercWebi/apiPlaceOrderConfig/removeAllStore`, data)
  },

  // 云打印-保存打印机信息
  saveCloudPrinter: data => {
    return post(`/mercWebi/cloudPrinter/savePrinter`, data)
  },
  // 云打印-打印配置列表
  getCloudPrinterList: data => {
    return post(`/mercWebi/cloudPrinter/printerList`, data)
  },
  // 云打印-删除打印配置
  deleteCloudPrinter: data => {
    return post(`/mercWebi/cloudPrinter/deletePrinter`, data)
  },
  // 云打印-修改关联店铺
  updateCloudPrinterStore: data => {
    return post(`/mercWebi/cloudPrinter/updatePrinterStore`, data)
  },
  // 云打印-修改关联商品
  updateCloudPrinterGoods: data => {
    return post(`/mercWebi/cloudPrinter/updatePrinterGoods`, data)
  },
  // 云打印-查询打印机关联店铺
  queryPrinterStoreList: data => {
    return post(`/mercWebi/cloudPrinter/queryPrinterStoreList`, data)
  },
  // 云打印-查询打印机关联商品
  queryPrinterGoodsList: data => {
    return post(`/mercWebi/cloudPrinter/queryPrinterGoodsList`, data)
  },

  // 营销活动-集点赠券保存
  saveCollectPointActivity: data => {
    return post(`/mercWebi/collectPointActivity/saveCollectPointActivity`, data)
  },
  // 营销活动-集点记录查询
  queryCollectPointDetail: data => {
    return post(`/mercWebi/collectPointActivity/queryCollectPointActivity`, data)
  },
  // 营销活动-集点记录查询
  queryCollectPointRecordList: data => {
    return post(`/mercWebi/collectPointActivity/queryCollectPointRecordList`, data)
  },

  // 团购核券-查询核销设置
  queryVerifyCouponParam: data => {
    return post(`/mercWebi/mercInfo/queryVerifyCouponParam`, data)
  },
  // 团购核券-修改核销设置
  updateVerifyCouponParam: data => {
    return post(`/mercWebi/mercInfo/updateVerifyCouponParam`, data)
  },
  // 团购核券-获取绑定抖音店铺链接
  getBindStoreUrl: data => {
    return post(`/mercWebi/busStoreInfo/getDyBindUrl`, data)
  },
  // 团购核券-授权店铺列表
  queryAuthStoreList: data => {
    return post(`/mercWebi/busStoreInfo/queryDyAuthStoreList`, data)
  },
  // 团购核券-撤销核销
  certificateCancel: data => {
    return post(`/mercWebi/busStoreInfo/certificateCancel`, data)
  },
  // 团购核券-抖音团购核销记录
  queryGroupCertificateCancel: data => {
    return post(`/mercWebi/busStoreInfo/queryDyCouponVerifyRecordList`, data)
  },
  // 会员折扣卡活动分页查询
  queryDiscountCardActivityPage: data => {
    return post(`/mercWeb/discountCardActivity/queryPage`, data)
  },
  // 会员折扣卡活动删除
  deleteDiscountCardActivity: data => {
    return post(`/mercWeb/discountCardActivity/deleteById`, data)
  },
  // 会员折扣卡活动保存/编辑
  saveDiscountCardActivity: data => {
    return post(`/mercWeb/discountCardActivity/save`, data)
  },
  // 会员折扣卡活动详情
  queryDiscountCardActivityDetail: data => {
    return post(`/mercWeb/discountCardActivity/queryById`, data)
  },
  // 会员折扣卡-用户卡列表
  queryUserDiscountCardPage: data => {
    return post(`/mercWeb/discountCardActivity/queryUserDiscountCardPage`, data)
  },
  // 会员折扣卡-修改
  updateDiscountCard: data => {
    return post(`/mercWeb/discountCardActivity/updateUserDiscountCard`, data)
  },
  // 会员折扣卡-交易明细
  queryUserDiscountCardRecordPage: data => {
    return post(`/mercWeb/discountCardActivity/queryUserDiscountCardRecordPage`, data)
  },
  // 会员折扣卡-活动列表
  queryDiscountCardList: data => {
    return post(`/mercWeb/discountCardActivity/queryList`, data)
  }
}

// export default {
//   inviteeList,
//   participantList,
//   participantStatistic,
//   authType,
//   goDetail,
//   wxAuthorizerInfobind,
//   wxAuthorizerInfodetail,
//   wxAuthorizerInfotoBind,
//   getUnbindCode,
//   unbind,
//   submitAudit,
//   checkAudit,
//   release,
//   queryCnt,
//   querySmsList,
//   smsSettingListByPage,
//   updateSmsSetting,
//   queryDelivery,
//   updateDelivery,
//   queryRegionList,
//   delRegion,
//   addRegion,
//   queryCouponList,
//   addCoupon,
//   queryCouponDetail,
//   editCoupon,
//   addActivity,
//   queryActivityList,
//   updateActivity,
//   queryActivityDetail,
//   updateStatus,
//   updateCouponStatus,
//   queryCount,
//   queryPack,
//   addPack,
//   updatePack,
//   addPackStatus,
//   PackageDetail,
//   cancellationUserCoupon,
//   addWorker,
//   queryWorkerList,
//   sysWorkerList,
//   delWorker,
//   addMercActivity,
//   selectStoreList,
//   VersionList,
//   listPartakeInfo,
//   listClusterInfo,
//   insertPartake,
//   partakeDetail,
//   updatePartake,
//   countPartakeInfo,
//   countClusterInfo,
//   listAdvertise,
//   insertAdvertise,
//   modifyAdvertise,
//   modifyStatus,
//   listStoreByStationId,
//   deleteAdvertise,
//   listAdvertisePosition,
//   advertiseDetail,
//   moveAdvertise,
//   updateWxappParam,
//   queryCustInfo,
//   queryApplyList,
//   checkWxappTemplate,
//   refreshWxappTemplate,
//   queryCardList,
//   addCard,
//   queryCardDetail,
//   deleteCard,
//   updateCard,
//   busGiftCardTop,
//   busGiftCardCancelTop,
//   queryGetOrSendDetail,
//   addQyNoticeRecipient,
//   updateGetOrSend,
//   removeStoreApi,
//   queryStoreWashList,
//   storeWashDetail,
//   storeWashAdd,
//   accountNoticePerson,
//   accountList,
//   washList,
//   washOrder,
//   getTableCodeList,
//   addTableCode,
//   deleteTableCodes,
//   updateTableCodeNo,
//   queryTableCodeDetails,
//   queryIsNewUser,
//   queryUserByMobileNos,
//   manualCouponIssuance,
//   queryCradExchangeList,
//   updateCradExchangeForStatus,
//   addCradExchange,
//   administratorPhone,
//   getLoginCode,
//   checkCode,
//   exportCardExchange,
//   queryCradExchangeExport,
//   settleCardPage,
//   settleCardAdd,
//   settleCardDetail,
//   settleCardUpdate,
//   settleCardRemarkUpdate,
//   settleCardFreeze,
//   queryRechargeList,
//   createWXQrCode,
//   queryRecordForSeq,
//   createSeq,
//   queryKoufeiList,
//   queryMeituanInfo,
//   settleCardList,
//   settleCardSeting,
//   settleCardDelete,
//   reToAuth,
//   updateMeituanInfo,
//   createAlipayQrCode,
//   queryWxAuthorizerInfoDetails,
//   updateWxAuthorizerInfo,
//   deliveryPage,
//   queryExpressDetail,
//   addInviteHim,
//   updateInviteHim,
//   queryInviteDetails,
//   queryInviteActivityList,
//   getExpressConfig,
//   expressConfigAdd,
//   expressConfigUpdate,
//   expressConfigDetail,
//   queryCityDeliveryIsEnable,
//   queryDeliveryBasicInfo,
//   updateDeliveryInfo,
//   deliverySort,
//   getDeductionRecordsList,
//   getPromoCodeInfoList,
//   addPromoCodeInfo,
//   updatePromoCodeInfo,
//   getPromoCodeDetail,
//   addExchangeSecreKey,
//   getPromoCodeExchangeList,
//   updateExchangeStatus,
//   addExchangeLabel,
//   deleteExchangeLabel,
//   exportPromoExchange,
//   exportPromoExchangeByParams,
//   queryCustomMenu,
//   addCustomMenu,
//   delCustomMenu,
//   cityCreateSeq,
//   cityCreateWXQrCode,
//   cityCreateAlipayQrCode,
//   cityQueryRecordForSeq,
//   queryBusinessBodyList,
//   getSfExpressConfig,
//   sfSettleCardPage,
//   querySfBusinessBodyList,
//   sfExpressConfigAdd,
//   sfSettleCardAdd,
//   sfExpressConfigDetail,
//   sfSettleCardDetail,
//   sfExpressConfigUpdate,
//   sfSettleCardRemarkUpdate,
//   querySfKoufeiList,
//   querySFRechargeList,
//   modifyMercDyTime,
//   queryMercDyTime,
//   modifyMercDyConfig,
//   queryMercDyGroupBuying,
//   createMercDyGroupBuying,
//   updateMercDyGroupBuying,
//   deleteMercDyGroupBuying,
//   getHomemakingSettings,
//   updateHomemakingSettings,
//   addHomemakingSettings,
//   setHomemakingOfficialPerson,
//   getHomemakingAccountList,
//   queryLeaderList,
//   queryGroupMemberList,
//   addLeader,
//   delLeader,
//   removeLeader,
//   queryOrderCommission,
//   getDistributionParam,
//   saveDistributionParam,
//   modifyCommission,
//   modifyCommissionExpireDate,
//   queryLeaderRelList,
//   editLeaderRelTeamUnit,
//   getInsureInfoList,
//   getInsureInfoDetail,
//   getFindorderList,
//   getTeamUnitList,
//   getTeamUnitSelectList,
//   saveTeamUnit,
//   getTeamUnitDetail,
//   deleteTeamUnit,
//   saveTeamUnitGroup,
//   getListTeamUnitGroup,
//   deleteGroupById,
//   sortTeamUnitGroup,
//   getListGroupUser,
//   addGroupUser,
//   editGroupUser,
//   deleteGroupUser,
//   querySmartDevice,
//   querySmartDeviceList,
//   smartDeviceDetail,
//   refreshDeviceStatus,
//   optSmartDevice,
//   saveDeviceImages,
//   deleteDeviceImage,
//   deviceImageSort,
//   updateRoadBagNum,
//   updateVoiceSetting,
//   getVoiceSettingList,
//   smartDeviceUpdateBox,
//   smartDeviceUnbindOrder,
//   smartDeviceOpenBox,
//   queryChatLogList,
//   queryChatLogDetail,
//   queryDyListPage,
//   insertThirdGroupInfo,
//   updateThirdGroupInfo,
//   queryCategoryList,
//   queryDyStoreList,
//   queryDyDetail,
//   operateDyGoods,
//   deleteDyGoods,
//   sortDyGoods,
//   synchronousDyGoods,
//   getDyGoodsCount,
//   getDyStoreList,
//   getStorePartnerList,
//   addStorePartner,
//   partnerCommissionList,
//   enableStorePartner,
//   getMercPartner,
//   bindStorePartner,
//   updateStorePartner,
//   getListByStoreId,
//   deleteStorePartner,
//   consumeCouponRuleList,
//   consumeCouponRuleSave,
//   consumeCouponRuleStatus,
//   consumeCouponRuleDetail,
//   consumeCouponRuleDelete,
//   saveWashCode,
//   getWashCodeList,
//   getWashCodeDetail,
//   updateWashCodeStatus,
//   queryServiceButler,
//   apiPlaceOrderConfigList,
//   saveApiPlaceOrderConfig,
//   apiPlaceOrderConfigDetail,
//   queryBindApiStoreList,
//   queryNotBindApiStoreList,
//   batchBindApi,
//   removeAllStoreApi,
//   saveCloudPrinter,
//   getCloudPrinterList,
//   deleteCloudPrinter,
//   updateCloudPrinterStore,
//   updateCloudPrinterGoods,
//   queryPrinterStoreList,
//   queryPrinterGoodsList,
//   saveCollectPointActivity,
//   queryCollectPointDetail,
//   queryCollectPointRecordList
// }
